import { CustomerNotification } from '@shared-ui/customer-notifications';
import * as React from 'react';
import { useStores } from '../../utils/hooks';
export var CustomerNotifications = function (_a) {
  var location = _a.location,
    regionId = _a.regionId,
    startDate = _a.startDate,
    endDate = _a.endDate,
    className = _a.className;
  var page = useStores().page;
  if (!page || !page.pageId) {
    return null;
  }
  return React.createElement("div", {
    className: className,
    "data-testid": "customer-notifications"
  }, React.createElement(CustomerNotification, {
    inputs: {
      xPageId: page.pageId,
      notificationLocation: location,
      optionalContext: {
        journeyCriterias: [{
          destination: {
            regionId: regionId
          },
          dateRange: {
            start: startDate,
            end: endDate
          }
        }]
      }
    }
  }));
};